import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@material-ui/core'

export default function PrivilegeTooltipWrapper ({ show, privileges, children }) {
  const { t } = useTranslation()

  function getTooltipTitle () {
    return show ?
      t('userGroups.form.dependentPrivilegeMessage') + ' ' + privileges.map(p => t('privileges.' + p)).join(', ')
      : ''
  }

  return (
    <Tooltip
      title={getTooltipTitle()}
      arrow>
      {children}
    </Tooltip>
  )
}